import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ThemeService } from "src/app/core/services/theme.service";
import { TopbarComponent } from "src/app/layout/topbar/topbar.component";
import { PasswordExpiryAlertComponent } from "../alerts/password-expiry-alert/password-expiry-alert.component";
import { BottomMenuInternalViewComponent } from "../bottom-menu/bottom-menu-internal-view/bottom-menu-internal-view.component";
import { SideMenuInternalViewsComponent } from "../side-menu-internal-views/side-menu-internal-views.component";

@Component({
	selector: "app-internal-view-layout",
	templateUrl: "./internal-view-layout.component.html",
	imports: [
		SideMenuInternalViewsComponent,
		TopbarComponent,
		RouterOutlet,
		PasswordExpiryAlertComponent,
		BottomMenuInternalViewComponent,
	],
})
export class InternalViewLayoutComponent implements OnInit, OnDestroy {
	private theme = inject(ThemeService);

	ngOnInit(): void {
		this.theme.switchTheme("INTERNAL_VIEW");
	}

	ngOnDestroy(): void {
		this.theme.switchTheme("DEFAULT");
	}
}
